/**
 * Códigos de error de la API. El backend los devuelve en el cuerpo del error y
 * el frontend los traduce con la clave `errores.ERR-NNN` del namespace i18n `common`;
 * nunca se muestra el código crudo.
 * Se amplían con la nomenclatura `ERR-NNN` secuencial (sin prefijo de dominio); ver la tabla de
 * equivalencia con el vocabulario del cliente más abajo.
 *
 * Equivalencia con el vocabulario de la especificación del cliente (nomenclatura `ERR-NNN`
 * cerrada — no sustituir por nombres semánticos):
 *
 * | Clave                      | Código   | HTTP | Nombre en la especificación    |
 * |-----------------------------|----------|------|---------------------------------|
 * | `internal`                 | `ERR-000`| 500  | `INTERNAL`                     |
 * | `validation`               | `ERR-001`| 400  | `VALIDATION_FAILED`            |
 * | `notFound`                 | `ERR-002`| 404  | `RESOURCE_NOT_FOUND`           |
 * | `forbidden`                | `ERR-003`| 403  | `FORBIDDEN`                    |
 * | `conflict`                 | `ERR-004`| 409  | `RESOURCE_CONFLICT`            |
 * | `relatedNotFound`          | `ERR-005`| 422  | `RELATED_RESOURCE_NOT_FOUND`   |
 * | `unauthorized`             | `ERR-006`| 401  | `AUTH_INVALID_TOKEN`           |
 * | `rateLimited`              | `ERR-007`| 429  | —                               |
 * | `authInvalidCredentials`   | `ERR-008`| 401  | —                               |
 * | `authEmailAlreadyRegistered`| `ERR-009`| 409 | —                               |
 * | `authEmailNotConfirmed`    | `ERR-010`| 403  | —                               |
 * | `authLinkExpired`          | `ERR-011`| 400  | —                               |
 * | `authProviderFailed`       | `ERR-012`| 400  | —                               |
 * | `authPasswordRejected`     | `ERR-013`| 400  | —                               |
 * | `organizerConditionsRequired`| `ERR-014`| 422| —                             |
 */
export const ERROR_CODES = {
	authEmailAlreadyRegistered: 'ERR-009',
	authEmailNotConfirmed: 'ERR-010',
	authInvalidCredentials: 'ERR-008',
	authLinkExpired: 'ERR-011',
	authPasswordRejected: 'ERR-013',
	authProviderFailed: 'ERR-012',
	conflict: 'ERR-004',
	forbidden: 'ERR-003',
	internal: 'ERR-000',
	notFound: 'ERR-002',
	// Entrega del cliente 18/09/2026 (`2-legal/consentimientos-y-firma.md` §5): "Toda
	// experiencia presencial se publica con las condiciones de quien la organiza. Sin ellas no
	// se publica" — `POST /experiences/:id/publish` responde este código cuando
	// `intakeMeta.condicionesPropias` está vacío. 422 porque la experiencia existe y es válida
	// como borrador; lo que falta es una condición de negocio para el siguiente paso (mismo
	// nivel HTTP que `relatedNotFound`), no un dato con forma incorrecta (`validation`, 400).
	organizerConditionsRequired: 'ERR-014',
	rateLimited: 'ERR-007',
	relatedNotFound: 'ERR-005',
	unauthorized: 'ERR-006',
	validation: 'ERR-001',
} as const;

export type ErrorCode = (typeof ERROR_CODES)[keyof typeof ERROR_CODES];
